export enum HttpStatusCodeEnum {
  Ok = 200,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  RequestTimeout = 408,
  InternalServerError = 500,
  ServiceUnavailable = 503,
}
